var exports = {
  "Q": "xe564cbfb--5b9ea8--text",
};

module.exports = exports;
